"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ({ pathname, search }) => pathname + search;
//# sourceMappingURL=getPath.js.map